import {
    GET_VEHICLE_LIST_PROGRESS, GET_VEHICLE_LIST_SUCCESS, GET_VEHICLE_LIST_FAILURE,
    ADD_VEHICLE_PROGRESS, ADD_VEHICLE_SUCCESS, ADD_VEHICLE_FAILURE,
    EDIT_DELETE_VEHICLE_PROGRESS, EDIT_DELETE_VEHICLE_SUCCESS, EDIT_DELETE_VEHICLE_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    vehicle: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const vehicle_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_VEHICLE_LIST_SUCCESS:
            return { ...state, vehicle: action.vehicle, loading: false };
        case GET_VEHICLE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_VEHICLE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_VEHICLE_PROGRESS:
            return { ...state, loading: true };
        case ADD_VEHICLE_SUCCESS:
            return { ...state, vehicle: [...state.vehicle, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_VEHICLE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_VEHICLE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_VEHICLE_SUCCESS:
            return {
                ...state,
                vehicle: state.vehicle.map((vehicle) =>
                    vehicle.id === action.payload.id ? action.payload : vehicle
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_VEHICLE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default vehicle_reducer;